import { ONE_ELEMENT, DEFAULT_VALUE, PERCENT } from 'util/constants';
import {getColors} from 'util/charts';
import {getVendorColor} from 'modules/store/vendors';


export const getColor = (item, index) => item.section === 'vendor' ?
    getVendorColor(item.id) :
    getColors(index + ONE_ELEMENT).pop();

export const createChartItem = (item, levels, type) => {
    const level = levels.indexOf(type);

    return {
        ...item,
        hasDrilldown: levels.length !== level + ONE_ELEMENT,
        level
    };
};
export const createChart = (tree, levels, name, handler) => {
    const total = tree.items.reduce((ret, item) => ret + item.amount, DEFAULT_VALUE);

    const ret = {
        ...module.exports.createConfig(handler),
        series: [{
            name,
            ...tree.items.reduce((_ret, item, index) => {
                const newColors = _ret.colors.slice();
                const newData = _ret.data.slice();

                newColors.push(module.exports.getColor({
                    ...item,
                    section: tree.type
                }, index));
                newData.push({
                    item:  module.exports.createChartItem(item, levels, tree.type),
                    code:  item.id,
                    name:  item.name,
                    y:     item.amount / total * PERCENT,
                    color: item.color
                });

                return {
                    data:   newData,
                    colors: newColors
                };
            }, {
                colors: [],
                data:   []
            })
        }]
    };

    return ret;
};

export const createTableTitle = (selectedLevel, initTitle) => [initTitle]
    .concat(selectedLevel);

export const createConfig = handler => {
    const SPACING_CHART = 20;

    return {
        chart: {
            spacing:   [SPACING_CHART, SPACING_CHART, SPACING_CHART, SPACING_CHART],
            type:      'pie',
            className: 'report-highcharts'
        },
        title:       null,
        plotOptions: {
            series: {
                events: {
                    click: handler
                },
                dataLabels: {
                    enabled: true,
                    format:  '<span style="font-size:11px">{series.name}</span><br><span style="font-size: 14px">{point.name}</span><br>{point.y:.2f}% ',
                    style:   {
                        fontFamily:     'Rubik-Medium',
                        fontWeight:     'normal',
                        textDecoration: 'none'
                    }
                }
            }
        },
        tooltip: {
            enabled: false
        }
    };
};



// WEBPACK FOOTER //
// ./src/util/reports.js